import React from 'react'
import './Footer.css'
import ReactDOM from 'react-dom'
import AccessTimeSharpIcon from '@material-ui/icons/AccessTimeSharp';
import EmailIcon from '@material-ui/icons/Email';
import GitHubIcon from '@material-ui/icons/GitHub';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import PhoneIcon from '@material-ui/icons/Phone';
import CodeIcon from '@material-ui/icons/Code';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import {Link} from "react-router-dom";

function Footer()
{
  return (

<div>
    <div className="footer-div">

     <div className="footer-links">

        <h1>Profession Links</h1>
         <div>
           <div className="Geek_Footer">
 <AccessTimeSharpIcon/>
 </div>
    <a href="http://linkedin.com/in/harshit-agrawal-a4708a153"><h4>Linkdin</h4>
</a>
         </div>
         <div>
        <div className="Git_Footer">
        <GitHubIcon/>
        </div>
        <a href="https://github.com/harshitagrawal7733" ><h4>Github</h4></a>
         </div>
         <div>
           <div className="code_Footer">
        <CodeIcon/>
        </div>
        <a href="https://www.geeksforgeeks.org/"> <h4>GeekforGeeks</h4></a>
         </div>

     </div>
     <div className="footer-links">
        <h1>Work</h1>
        <div>
        <h4>amazon-clone</h4>

        </div>
        <div>
          <h4>Food-website</h4>
        </div>
        
     </div>
     <div className="footer-links">
        <h1>Social links</h1>
        <div>
        <div className="Facebook_Footer">
          <FacebookIcon/>
        </div>
        <h5>Facebook</h5>
        </div>
        <div>
          <div className="instagram_Footer">
        <InstagramIcon/>
        </div>
        <h5>instagram</h5>
        </div>
     </div>
     <div className="footer-links">
        <h1>Contact</h1>
        <EmailIcon/>
        <h4>agrawalharshit7733@gmail.com</h4>
        <MyLocationIcon/>
        <h3>Jaipur,Rajasthan</h3>
        <PhoneIcon/>
        <h3>+91 7014376467</h3>

     </div>

     </div>
<h4 className="footer-copyright">Made with ❤️  by Harshit agrawal</h4>
    </div>

  )
}


export default Footer
